import { render, staticRenderFns } from "./Zipcode.vue?vue&type=template&id=bdd606d2"
import script from "./Zipcode.vue?vue&type=script&lang=js"
export * from "./Zipcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports